<template>
  <section class="invoice-add-wrapper">
    <b-row
      v-if="order"
      class="invoice-add"
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-form @submit.prevent>
          <b-card
            no-body
            class="invoice-preview-card"
          >
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">

              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <img
                      src="@/assets/images/logo/logo bioherbs-01.png"
                      width="200px"
                      height="auto"
                    >                    <h3 class="text-primary invoice-logo" />
                  </div>
                  <b-card-text class="mb-0">
                    Route Lido Dar Chabane , 8000 Nabeul
                  </b-card-text>
                  <b-card-text class="mb-0">
                    contact@bioherbs.tn
                  </b-card-text>
                  <b-card-text class="mb-0">
                    www.bioherbs.tn
                  </b-card-text>
                  <b-card-text class="mb-0">
                    +216 24 289 289
                  </b-card-text>
                  <b-card-text class="mb-0">
                    MF : 000MB1704494/H
                  </b-card-text>

                </div>

                <!-- Header: Right Content -->
                <div
                  v-if="order"
                  class="invoice-number-date mt-md-0 mt-2"
                >
                  <div class="d-flex align-items-center justify-content-md-end mb-1">
                    <h4 class="invoice-title" />
                    <h4 class="invoice-title" />

                    <b-input-group class="input-group-merge invoice-edit-input-group disabled">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="HashIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="invoice-data-id"
                        v-model="order.reference"
                      />
                    </b-input-group>
                  </div>
                  <div class="d-flex align-items-center mb-1">
                    <span class="title">
                      Date:
                    </span>
                    <flat-pickr
                      v-model="invoiceData.date"
                      class="form-control invoice-edit-input"
                    />
                  </div>

                </div>
              </div>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Invoice Client & Payment Details -->
            <b-card-body
              class="invoice-padding pt-0"
            >
              <b-row class="invoice-spacing">

                <!-- Col: Invoice To -->
                <b-col
                  cols="12"
                  xl="6"
                  class="mb-lg-1"
                >
                  <h6 class="mb-2">
                    vente pour:
                  </h6>
                  <!-- Select Client -->
                  <v-select
                    v-model="order.customer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="clients"
                    label="company_name"
                    input-id="invoice-data-client"
                    :clearable="false"
                  >
                    <template #list-header>
                      <li
                        v-b-toggle.sidebar-invoice-add-new-customer
                        class="add-new-client-header d-flex align-items-center my-50"
                      >
                        <feather-icon
                          icon="PlusIcon"
                          size="16"
                        />
                        <span class="align-middle ml-25">Ajouter un noveau client</span>
                      </li>
                    </template>
                  </v-select>

                  <!-- Selected Client -->
                  <div
                    v-if="order.customer"
                    class="mt-1"
                  >
                    <h6
                      class="mb-25"
                    >
                      Client : {{ order.customer.company_name }}
                    </h6>
                    <b-card-text class="mb-25">
                      Adresse : {{ order.customer.address }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      Email : {{ order.customer.email }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      Tel : {{ order.customer.phone }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      MF/CIN : {{ order.customer.tax_identification_number }}
                    </b-card-text>
                  </div>
                </b-col>
                <feather-icon
                  size="16"
                  icon="XOctagonIcon"
                  class="cursor-pointer mt-4"
                  @click="order.customer=null"
                />

              </b-row>
            </b-card-body>

            <!-- Items Section -->
            <b-card-body class="invoice-padding form-item-section">
              <div
                ref="form"
                class="repeater-form"
                :style="{height: trHeight}"
              >
                <b-row
                  v-for="(item, index) in invoiceData.items"
                  :key="index"
                  ref="row"
                  class="pb-2"
                >
                  <!-- Item Form -->
                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">

                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <b-row class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          Référence
                        </b-col>
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          Labelle
                        </b-col>

                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Prix de gros
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Quantité
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Prix total
                        </b-col>
                      </b-row>
                      <div class="form-item-action-col" />
                    </div>

                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          <label class="d-inline d-lg-none">Item</label>
                          <v-select
                            v-model="item.produit"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="itemsOptions"
                            label="reference"
                            :clearable="false"
                            class="mb-2 item-selector-title"
                            placeholder="Select Item"
                            disabled
                            @input="val => updateItemForm(index, val)"
                          />

                        </b-col>
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          <label class="d-inline d-lg-none">Labelle</label>
                          <b-form-input
                            v-if="item.produit.reference != '' && item.produit.name == ''"
                            v-model="item.produit.name"
                            class="mb-2"
                            disabled
                          />
                          <v-select
                            v-else
                            v-model="item.produit"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="itemsOptions"
                            label="name"
                            :clearable="false"
                            class="mb-2 item-selector-title"
                            placeholder="Select Item"
                            disabled
                            @input="val => updateItemForm(index, val)"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Prix de gros</label>
                          <b-form-input
                            v-model="item.produit.wholesale_price"
                            type="number"
                            class="mb-2"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Qty</label>
                          <b-form-input
                            v-model="item.qty"
                            value="1"
                            type="number"
                            class="mb-2"
                            @change="alertt(item.produit.quantity,item.qty,item.old_quantity,index)"
                          />
                        </b-col>

                        <b-col

                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Prix</label>
                          <p class="mb-1">
                            {{ (item.produit.wholesale_price * item.qty).toFixed(3) }}
                          </p>
                        </b-col>

                      </b-row>
                      <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                        <feather-icon
                          size="16"
                          icon="XIcon"
                          class="cursor-pointer"
                          @click="removeOld(index,item)"
                        />

                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row
                  v-for="(item, id) in invoiceDataNew.items"
                  :key="id"
                  ref="row"
                  class="pb-2"
                >
                  <!-- Item Form -->
                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">

                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <b-row class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          Référence
                        </b-col>
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          Labelle
                        </b-col>

                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Prix de gros
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Quantité
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Prix total
                        </b-col>
                      </b-row>
                      <div class="form-item-action-col" />
                    </div>

                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          <label class="d-inline d-lg-none">Item</label>
                          <v-select
                            v-model="item.produit"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="itemsOptions"
                            label="reference"
                            :clearable="false"
                            class="mb-2 item-selector-title"
                            placeholder="Select Item"
                            @input="setSelected(item.produit,index)"
                          />

                        </b-col>
                        <b-col
                          cols="12"
                          lg="3"
                        >
                          <label class="d-inline d-lg-none">Labelle</label>
                          <b-form-input
                            v-if="item.produit.reference != '' && item.produit.name == ''"
                            v-model="item.produit.name"
                            class="mb-2"
                          />
                          <v-select
                            v-else
                            v-model="item.produit"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="itemsOptions"
                            label="name"
                            :clearable="false"
                            class="mb-2 item-selector-title"
                            placeholder="Select Item"
                            @input="setSelected(item.produit,index)"
                          />
                        </b-col>

                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Prix de gros</label>
                          <b-form-input
                            v-model="item.produit.wholesale_price"
                            type="number"
                            class="mb-2"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Qty</label>
                          <b-form-input
                            v-model="item.qty1"
                            value="1"
                            type="number"
                            class="mb-2"
                            :on-change="alertt1(item.produit.quantity,item.qty1,index)"
                          />
                        </b-col>

                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Prix</label>
                          <p class="mb-1">
                            {{ (item.produit.wholesale_price * item.qty1).toFixed(3) }}
                          </p>
                        </b-col>

                      </b-row>
                      <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                        <feather-icon
                          size="16"
                          icon="XIcon"
                          class="cursor-pointer"
                          @click="removeNew(index)"
                        />

                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                @click="addNewItemInItemForm"
              >
                Ajouter produit
              </b-button>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>

                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3 d-flex align-items-center"
                  order="2"
                  order-md="1"
                >
                  <label
                    for="invoice-data-sales-person"
                    class="text-nowrap mr-50"
                  >Remise</label>
                  <b-form-input
                    id="invoice-data-sales-person"
                    v-model="order.remise"
                    placeholder="Edward Crowley"
                  />
                  <span class="ml-2">%</span>
                </b-col>

                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div
                      v-if="somme"
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Total HT:
                      </p>
                      <p class="invoice-total-amount">
                        {{ somme.toFixed(3) }} DT
                      </p>
                    </div>
                    <div
                      v-else
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Total HT:
                      </p>
                      <p class="invoice-total-amount">
                        0
                      </p>
                    </div>

                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Tax 19 %:
                      </p>
                      <p
                        v-if="somme"
                        class="invoice-total-amount"
                      >
                        {{ tax }} DT
                      </p>
                      <p
                        v-else
                        class="invoice-total-amount"
                      >
                        0
                      </p>
                    </div>

                    <hr class="my-50">
                    <div
                      v-if="somme"
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Prix T.T.C:
                      </p>
                      <p class="invoice-total-amount">
                        {{ sommeTTC }} DT
                      </p>
                    </div>
                    <div
                      v-else
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Prix T.T.C:
                      </p>
                      <p class="invoice-total-amount">
                        0
                      </p>
                    </div>
                  </div></b-col></b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">Note: </span>
              <b-form-textarea v-model="invoiceData.note" />
            </b-card-body>
          </b-card>
        </b-form>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions mt-md-0 mt-2"
      >

        <!-- Action Buttons -->
        <b-card>

          <!-- Button: Send Invoice -->

          <!-- Button: DOwnload -->

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            block
            @click="update"
          >
            Enregistrer
          </b-button>
        </b-card>

      </b-col>
    </b-row>
    <invoice-sidebar-add-new-customer />

  </section>

</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormInput, BInputGroup, BInputGroupPrepend, BFormTextarea, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import InvoiceSidebarAddNewCustomer from './AddClient.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    flatPickr,
    vSelect,
    InvoiceSidebarAddNewCustomer,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,

  },
  mixins: [heightTransition],
  data() {
    return {
      order: '',
    }
  },

  computed: {

    somme() {
      if (this.order.remise === 0) {
        const s = this.invoiceData.items.reduce((accumulator, item) => accumulator + (item.produit.wholesale_price * item.qty), 0)
        if (this.invoiceDataNew.length !== 0) {
          const n = this.invoiceDataNew.items.reduce((accumulator, item) => accumulator + (item.produit.wholesale_price * item.qty1), 0)

          return s + n
        }
        return s
      }

      const s = this.invoiceData.items.reduce((accumulator, item) => accumulator + (item.produit.wholesale_price * item.qty), 0)
      if (this.invoiceDataNew.length !== 0) {
        const n = this.invoiceDataNew.items.reduce((accumulator, item) => accumulator + (item.produit.wholesale_price * item.qty1), 0)

        const somme = s + n
        return (somme - ((somme * this.order.remise) / 100))
      }
      return (s - ((s * this.order.remise) / 100))
    },
    sommeTTC() {
      return ((Number(this.somme) * (1 + (19 / 100)))).toFixed(3)
    },
    tax() {
      return (Number(this.somme) / (100 / 19)).toFixed(3)
    },
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    this.getOrder()
    this.invoiceData.items.shift()
    this.invoiceDataNew.items.shift()

    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    setSelected(value, index) {
      for (let i = 0; i < this.invoiceData.items.length; i += 1) {
        if (this.invoiceData.items[i].produit.reference === value.reference) {
          this.invoiceData.items[i].qty = Number(this.invoiceData.items[i].qty) + 1
          if (this.invoiceData.items[i].qty > 1) { this.removeNew(index) }
        }
      }
    },
    alertt1(quantity, qty, index) {
      if (quantity < qty) {
        // eslint-disable-next-line no-param-reassign

        this.withTitle1(quantity, index)
      }
    },
    alertt(quantity, qty, old, index) {
      if (quantity < (qty - old)) {
        // eslint-disable-next-line no-param-reassign

        this.withTitle(quantity, old, index)
      }
    },
    withTitle(quantity, old, index) {
      this.$swal({
        title: 'Stock Alerte',
        icon: 'warning',
        text: `Quantité demandé est superieur au stock       il vous reste que ${quantity} pièce`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const item = this.invoiceData.items.slice(index, index + 1)
          item[0].qty = old
        }
      })
    },
    withTitle1(quantity, index) {
      this.$swal({
        title: 'Stock Alerte',
        icon: 'warning',
        text: `Quantité demandé est superieur au stock       il vous reste que ${quantity} pièce`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.removeNew(index)
        }
      })
    },
    async getOrder() {
      await this.$http.get(`/orders/detail/${this.$route.params.id}/`).then(response => {
        this.order = response.data
      })
      if (this.order != null) {
        this.$http.post(
          '/orders-products/details/',
          { order: this.order.id, products: this.order.products },
        ).then(res => {
          const result = res.data
          for (let i = 0; i < result.length; i += 1) {
            this.order.products[i].wholesale_price_ttc = result[i].price_ttc
            const itemFormBlankItem = {
              item: null,
              produit: this.order.products[i],
              qty: result[i].quantity,
              old_quantity: result[i].quantity,
            }

            this.invoiceData.items.push(JSON.parse(JSON.stringify(itemFormBlankItem)))
          }
          if (this.order.remise !== 0) {
            this.somme -= Number((this.somme * this.order.remise) / 100)
          }
        })
      }
    },

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },

    async update() {
      let customer = null
      if (this.order.customer) {
        customer = this.order.customer.id
      }
      await axios.post('/orders/update-orders-product/', {
        reference: this.order.reference,
        note: this.order.note,
        status: this.order.status,
        date: this.order.date,
        total_ht: this.somme.toFixed(3),
        total_ttc: this.sommeTTC,
        products: this.invoiceDataNew.items,
        products_old: this.invoiceData.items,
        order: this.order.id,
        remise: this.order.remise,
        customer,
        tax: this.tax,
      }).then(() => {
        this.$router.push({ name: 'commande-list' })
        this.showToast('success', 'top-center', 'commande modifier avec succès')
      })
        .catch(() => {
          this.showToast('danger', 'top-center', 'Vérifier votre stock')
        })
    },

    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.invoiceDataNew.items.push(JSON.parse(JSON.stringify(this.itemFormBlankItemNew)))

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => {
          this.$refs.form.style.overflow = null
        }, 350)
      })
    },

    async removeOld(index) {
      this.$swal({
        showCancelButton: true,
        title: 'Vous êtes sur !!',
        icon: 'warning',
        text: 'vous êtes sur de supprimer ce produit de la commande',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          const slice = this.invoiceData.items.splice(index, index + 1)
          await axios
            .post(
              '/orders/delete-product/',
              { order: this.order, product: slice[0].produit },
            )
          let customer = null
          if (this.order.customer) {
            customer = this.order.customer.id
          }
          await axios.post('/orders/update-orders-product/', {
            reference: this.order.reference,
            note: this.order.note,
            status: this.order.status,
            date: this.order.date,
            total_ht: this.somme.toFixed(3),
            total_ttc: this.sommeTTC,
            products: this.invoiceDataNew.items,
            products_old: this.invoiceData.items,
            order: this.order.id,
            remise: this.order.remise,
            customer,
            tax: this.tax,
          })
          this.trTrimHeight(this.$refs.row[0].offsetHeight)
        }
      })
    },
    removeNew(index) {
      this.invoiceDataNew.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },

    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        // this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
  setup() {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const clients = ref([])
    axios.get('/customers/', { params: { type: 'client morale' } }).then(response => {
      clients.value = response.data
    })

    const itemFormBlankItem = {
      item: null,
      produit: {
        wholesale_price: 0,
        reference: '',
      },
      qty: 0,
    }
    const itemFormBlankItemNew = {
      item: null,
      produit: {
        wholesale_price: 0,
        reference: '',
      },
      qty1: 1,
    }
    const orders = ref([])
    const current = new Date()

    const invoiceData = ref({
      id: '',
      client: null,
      date: `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: '',
      note: '',
      paymentMethod: null,
    })
    const invoiceDataNew = ref({
      id: '',
      client: null,
      date: `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: '',
      note: '',
      paymentMethod: null,
    })

    const itemsOptions = ref([])
    axios.get('/products/').then(response => {
      itemsOptions.value = response.data
    })

    const remise = 0

    const updateItemForm = (index, val) => {
      const { cost, qty } = val
      invoiceData.value.items[index].cost = cost
      invoiceData.value.items[index].qty = qty
    }

    const paymentMethods = [
      'Bank Account',
      'PayPal',
      'UPI Transfer',
    ]

    return {
      invoiceData,
      invoiceDataNew,
      clients,
      itemsOptions,
      updateItemForm,
      itemFormBlankItemNew,
      itemFormBlankItem,
      paymentMethods,
      orders,
      remise,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
      color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
background-color:$product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}
</style>
